import React from 'react';
import { Link } from 'react-router-dom';

function Refunds() {
  return (
    <main className="App-main">
      <section className="dashboard-section" style={{ maxWidth: '840px', margin: '0 auto' }}>
        <h2>Refund Policy</h2>
        <p className="status-text">Last updated: February 14, 2026</p>
        <p className="status-text">
          Subscriptions renew automatically. If you believe you were charged in error or need assistance,
          please contact support. Refunds are reviewed on a case-by-case basis.
        </p>
        <ul>
          <li>Contact support within 7 days of a charge to request review.</li>
          <li>Approved refunds are issued to the original payment method.</li>
          <li>We may refuse refunds for abusive or fraudulent activity.</li>
        </ul>
        <p className="status-text">For questions, <Link to="/contact">contact support</Link>.</p>
      </section>
    </main>
  );
}

export default Refunds;
